import { render, staticRenderFns } from "./BrandDownloadNew.vue?vue&type=template&id=e2290352&scoped=true"
import script from "./BrandDownloadNew.vue?vue&type=script&lang=js"
export * from "./BrandDownloadNew.vue?vue&type=script&lang=js"
import style0 from "./BrandDownloadNew.vue?vue&type=style&index=0&id=e2290352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_cache-loader@4.1.0_webpack@4.47.0__css-load_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2290352",
  null
  
)

export default component.exports